/**
 * @file src/store/issueFormStore.ts
 * @fileoverview Zustand-store voor het beheren van de status van het feedbackformulier.
 */
import { create } from 'zustand';

/**
 * Interface voor de state van het feedbackformulier.
 */
interface IssueFormState {
  /** Geeft aan of het formulier momenteel open is. */
  isOpen: boolean;
  /** Functie om het formulier te openen. */
  open: () => void;
  /** Functie om het formulier te sluiten. */
  close: () => void;
}

/**
 * Een Zustand-store die de status van het feedbackformulier beheert.
 * Het houdt bij of het formulier geopend is en biedt functies om het te openen en te sluiten.
 */
export const useIssueFormStore = create<IssueFormState>((set) => ({
  isOpen: false,
  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
}));
